import GoogleMap from './map';

const sections = document.querySelectorAll('section.apartment-map');

if (sections.length) {
    sections.forEach(section => {
        const map = section.querySelector('[data-map]');
        if (map) {
            const instance = new GoogleMap(map, true, true);
        }
    });
}
